import "../Subscriptions/subscription.scss";
import classnames from "classnames";

const Subscription = ({
  href,
  src,
  alt,
  assignedColor,
  hrefPayment,
  paymentMessage,
  variant,
  showStatus,
}) => {
  return (
    <div>
      <a href={href} target="_blank" rel="noreferrer">
        <div
          className={classnames("subscription__item", {
            "subscription__item--orange": assignedColor === "orange",
            "subscription__item--rose": assignedColor === "rose",
            "subscription__item--white": assignedColor === "white",
            "subscription__item--green": assignedColor === "green",
            "subscription__item--blue": assignedColor === "blue",
          })}
        >
          <img src={src} alt={alt} />
        </div>
      </a>
      {showStatus && hrefPayment && (
        <a href={hrefPayment} target="_blank" rel="noreferrer">
          <p
            className={classnames("subscription__message", {
              "subscription__message--this-year": variant === "this-year",
              "subscription__message--next-year": variant === "next-year",
            })}
          >
            {paymentMessage}
          </p>
        </a>
      )}
      {showStatus && !hrefPayment && (
        <p
          className={classnames("subscription__message", {
            "subscription__message--this-year": variant === "this-year",
            "subscription__message--next-year": variant === "next-year",
          })}
        >
          {paymentMessage}
        </p>
      )}
    </div>
  );
};

export default Subscription;
